import { ButtonHTMLAttributes, ReactNode, FC } from "react"
import { PillButtonStyled } from './styles'

interface PillButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children?: ReactNode;
  selected?: boolean;
}

const PillButton: FC<PillButtonProps> = ({ children, ...rest }) => {

  return <PillButtonStyled {...rest}>{children}</PillButtonStyled>
}

export default PillButton